// extracted by mini-css-extract-plugin
export default {"TimerStyle":"common_TimerStyle__EAXOm"};